import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'James T.',
    role: 'Volunteer Coach',
    country: 'United States',
    text: 'I used to spend my entire Sunday night stressing over what to do at practice. Now I just open the app, pick the session for my age group, and go. The kids are more engaged than ever.'
  }, {
    name: 'Sarah M.',
    role: 'Academy Coach',
    country: 'United Kingdom',
    text: "The age development roadmaps are an absolute game-changer for my U9s. It's given our entire season a clear direction. Worth every penny just for the organization."
  }, {
    name: 'Mike R.',
    role: 'Club Coach',
    country: 'Australia',
    text: 'Having 200 session plans ready to go has saved me countless hours. I finally feel like a proper professional walking onto the pitch instead of just winging it.'
  }, {
    name: 'Laura K.',
    role: 'Parent Coach',
    country: 'Canada',
    text: 'I stepped up to coach because no one else would, but I had zero background. Soccer Ready made me feel completely prepared. The parents even complimented my sessions!'
  }, {
    name: 'Daniel O.',
    role: 'Youth Coach',
    country: 'New Zealand',
    text: 'The drill library is massive. I used to run out of ideas halfway through the season and the kids would get bored. Now every session feels fresh and purposeful.'
  }, {
    name: 'Priya S.',
    role: 'Grassroots Coach',
    country: 'South Africa',
    text: 'The player improvement is actually visible to the parents now, and that has completely changed the team culture. No more complaints, just supportive parents.'
  }];
  return <section className="bg-forest py-24 px-4 border-t border-white/5" data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-16 uppercase" data-id="element-211">
          What Coaches Are Saying
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-212">
          {testimonials.map((t, i) => <div key={i} className="bg-ink p-8 rounded-xl border border-white/5 relative" data-id="element-213">
              <div className="flex gap-1 mb-4" data-id="element-214">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-amber text-amber" data-id="element-215" />)}
              </div>
              <p className="text-gray-300 text-lg italic mb-6 leading-relaxed" data-id="element-216">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-217">
                <div className="w-10 h-10 rounded-full bg-forest flex items-center justify-center border border-white/10" data-id="element-218">
                  <span className="text-white font-bold" data-id="element-219">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-220">
                  <p className="text-white font-bold" data-id="element-221">{t.name}</p>
                  <p className="text-sm text-gray-400" data-id="element-222">
                    {t.role} • {t.country}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}